/**
 * Download / web entry URLs. Override via Vite env at build time.
 */
export const APP_VERSION = '1.0.0-alpha.1';

/** Hero「免费下载」滚动锚点，实际下载在平台卡片行 */
export const DOWNLOADS_SECTION_ID = 'downloads';

const ossReleaseBase = 'https://oss.blendviewer.com/public/6647b810-2c2e-11f1-b511-4b435a8bc2fa';

export type PlatformDownloadId = 'windows' | 'macos-arm64' | 'macos-x64' | 'linux' | 'web';

export interface PlatformDownload {
  id: PlatformDownloadId;
  label: string;
  hint: string;
  href: string;
  external?: boolean;
}

function envOr(key: string, fallback: string): string {
  const value = import.meta.env[key as keyof ImportMetaEnv];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

export const platformDownloads: PlatformDownload[] = [
  {
    id: 'windows',
    label: 'Windows',
    hint: 'Windows 10+',
    href: envOr('VITE_DOWNLOAD_WINDOWS', `${ossReleaseBase}/fustar-${APP_VERSION}-setup.exe`),
    external: true,
  },
  {
    id: 'macos-arm64',
    label: 'macOS',
    hint: 'Apple Silicon（M 系列）',
    href: envOr('VITE_DOWNLOAD_MACOS_ARM64', `${ossReleaseBase}/fustar-${APP_VERSION}-arm64.dmg`),
    external: true,
  },
  {
    id: 'macos-x64',
    label: 'macOS',
    hint: 'Intel 芯片',
    href: envOr('VITE_DOWNLOAD_MACOS_X64', `${ossReleaseBase}/fustar-${APP_VERSION}-x64.dmg`),
    external: true,
  },
  {
    id: 'linux',
    label: 'Linux',
    hint: 'AppImage',
    href: envOr('VITE_DOWNLOAD_LINUX', `${ossReleaseBase}/fustar-${APP_VERSION}-arm64.AppImage`),
    external: true,
  },
  {
    id: 'web',
    label: '在线使用',
    hint: '浏览器版',
    href: envOr('VITE_WEB_APP_URL', 'https://fustar-web.blendviewer.com'),
    external: true,
  },
];

/** 主 CTA 默认指向 Apple Silicon 安装包 */
export const primaryDownload =
  platformDownloads.find(p => p.id === 'macos-arm64') ?? platformDownloads[0]!;
